import Header from "../Common/Header/Header";
import { useSelector } from "react-redux";
import ReportSideBar from "../Common/SideBar/ReportSideBar";
import { useEffect, useState } from "react";
import CustomerWiseSalesReport from "./SalesReports/CustomerWiseSalesReport";
import CustomerWiseSalesReturnReport from "./SalesReports/CustomerWiseSalesReturnReport";
import DateWiseSalesReturnReport from "./SalesReports/DateWiseSalesReturnReport";
import DateWiseSalesWithDueReport from "./SalesReports/DateWiseSalesWithDueReport";
import InvoiceWiseGrossProfitReport from "./SalesReports/InvoiceWiseGrossProfitReport";
import ProductWiseSalesReport from "./SalesReports/ProductWiseSalesReport";
import UserWiseSalesReport from "./SalesReports/UserWiseSalesReport";
import DateWisePurchaseReport from "./PurchaseReports/DateWisePurchaseReport";
import UserWisePurchaseReport from "./PurchaseReports/UserWisePurchaseReport";
import ProductWisePurchaseReport from "./PurchaseReports/ProductWisePurchaseReport";
import SupplierWisePurchaseReport from "./PurchaseReports/SupplierWisePurchaseReport";
import InvoiceWiseProductReport from "./ProductReports/InvoiceWiseProductReport";
import ProfitLossReport from "./profitLossReports/ProfitLossReport";
import { useParams, useLocation } from 'react-router-dom';

const Reports = () => {
  const { reportKey } = useParams();
  const lang = useSelector((state) => state.languageReducer);

  const [active, setActive] = useState(reportKey || "customerWiseSalesReport");

  useEffect(() => {
    setActive(reportKey || "customerWiseSalesReport");
  }, [reportKey]);

  const renderComponent = () => {
    switch (active) {
      // sales report
      case "customerWiseSalesReport":
        return <CustomerWiseSalesReport />;
      case "customerWiseSalesReturnReport":
        return <CustomerWiseSalesReturnReport />;
      case "dateWiseSalesReturnReport":
        return <DateWiseSalesReturnReport />;
      case "dateWiseSalesWithDueReport":
        return <DateWiseSalesWithDueReport />;
      case "invoiceWiseGrossProfitReport":
        return <InvoiceWiseGrossProfitReport />;
      case "productWiseSalesReport":
        return <ProductWiseSalesReport />;
      case "userWiseSalesReport":
        return <UserWiseSalesReport />;
        // purchase report
      case "dateWisePurchaseReport":
        return <DateWisePurchaseReport />;
      case "supplierWisePurchaseReport":
        return <SupplierWisePurchaseReport />;
      case "productWisePurchaseReport":
        return <ProductWisePurchaseReport />;
      case "userWisePurchaseReport":
        return <UserWisePurchaseReport />;
        //products report
      case "invoiceWiseProductReport":
        return <InvoiceWiseProductReport />;
        //profit report
      case "profitLossReport":
        return <ProfitLossReport />;


      default:
        return <CustomerWiseSalesReport />;
    }
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-md-2">
            <SideBar></SideBar>
          </div> */}
          <div className="col-md-2">
            <ReportSideBar active={active} />
          </div>
          <div className="col-md-10">
            <Header title={lang?.allReports}></Header>

            {/* Components */}
            <div
              className="d-flex flex-column justify-content-center align-items-center text-center py-4"
              style={{ minHeight: "80vh" }}
            >
              <div className="w-100 d-flex justify-content-center">{renderComponent()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
